import React, { ReactElement } from 'react'
import styled from 'styled-components'
import useIsMobile from '../../helpers/isMobile'
import colors from '../../lib/colors'
import theme, { ZIndex } from '../../lib/theme'
import MenuControl from './MenuControl'

const Styles = styled.div`
  position: sticky;
  top: ${theme.headerHeight};
  height: calc(100vh - ${theme.headerHeight});
  width: 200px;
  transition: width 0.2s;
  ${theme.scrollbar}
  display: flex;
  flex-direction: column;
  background-color: ${colors.white};
  box-sizing: border-box;
  overflow-x: hidden;
  border-right: 2px solid ${(props): string => props.theme.primaryColor};
  &.menu-closed {
    width: 50px;
    ${(props): string => props.theme.isMobile && 'width: 0; border: 0;'};
  }
  ${(props): string => props.theme.isMobile && `position: fixed; z-index: ${ZIndex.Header}`};
  justify-content: space-between;
`

interface IMenuProps {
  content: ReactElement
  primaryColor: string
  secondaryColor: string
  menuCollapsed: boolean
  toggleMenu: (open?: boolean) => void
}
export default function Menu(props: IMenuProps): ReactElement {
  const {
    content, primaryColor, secondaryColor, menuCollapsed, toggleMenu,
  } = props
  const isMobile = useIsMobile()

  const mobileCloseOnClick = (): void => {
    if (isMobile) toggleMenu(false)
  }

  return (
    <Styles
      className={menuCollapsed ? 'menu-closed' : 'menu-open'}
      theme={{ isMobile, primaryColor, secondaryColor }}
      onClick={mobileCloseOnClick}
    >
      <React.Fragment>
        {content}
        {!isMobile && (
          <MenuControl
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            toggleMenu={toggleMenu}
            menuCollapsed={menuCollapsed}
          />
        )}
      </React.Fragment>
    </Styles>
  )
}
